module.exports = __webpack_public_path__ + "img/friends.9e503dcb.png";